<template>
  <edit-field
      ref="EDIT_CURRENCY"
      :bold="bold"
      :context-id=contextId
      :data-table="dataTable"
      :disabled=readOnly
      :edit-field-info=editFieldInfo
      :hide-label="hideLabel"
      :max=max
      :min=min
      :required=required
      :single-line=true
      :value="value == '0' ? '' : value"
      @context=setInitValue
      @error=setError
      @updated=setUpdated>
  </edit-field>
</template>

<script lang="ts">
import EditBase from '@/framework/base/components/EditBase';
import EditField from '@/framework/base/components/EditField.vue';
import {EditFieldType, FieldInfo, getFormat} from '@/framework/base/components/FieldInfo';
import validator, {rules, RULES_FRENCH_LABEL} from '@/generated/validators/ValidationRules';
import {FwkControls, RessourceFwkControl} from '@/ressources/globalRessources';
import {MapRessource} from '@/framework/base/helpers/Ressources';
import {defineComponent} from "vue";

export default defineComponent({
  components: {
    EditField
  },
  extends: EditBase,
  computed: {
    editFieldInfo(): FieldInfo {
      const type = EditFieldType.CURRENCY;
      const precision = 2;
      const format = getFormat('');
      const focus = this.focusValidator;
      const live = this.liveValidator;
      const mask = this.mask;
      return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
    },
    ressource() {
      if (this.libelle) {
        const customRessource = new MapRessource();
        customRessource.label = this.libelle;
        return customRessource
      } else {
        return RessourceFwkControl(FwkControls.MONTANT);
      }
    }
  },
  methods: {
    focusValidator(value: string): validator | null {
      return null;
    },
    liveValidator(value: string): validator | null {
      return new validator(rules.currency, RULES_FRENCH_LABEL.text.currency.error);
    },
    mask(value: string): string {
      return '';
    },
    missing(): boolean {
      // @ts-expect-error : generated method
      return this.$refs.EDIT_CURRENCY.missing();
    },
    touch(): boolean {
      // @ts-expect-error : generated method
      return this.$refs.EDIT_CURRENCY.touch();
    },
    setFocus(): void {
      // @ts-expect-error : generated method
      this.$refs.EDIT_CURRENCY.setFocus();
    }
  }
})

</script>
